const LAYOUTS = {
    '2x2': [
        { top: 0, left: 0, width: .5, height: .5 },
        { top: 0, left: .5, width: .5, height: .5 },
        { top: .5, left: 0, width: .5, height: .5 },
        { top: .5, left: .5, width: .5, height: .5 }
    ],
    '3x1': [
        { top: .125, left: .375, width: .25, height: .75 },
        { top: .25, left: .0625, width: .25, height: .5 },
        { top: .25, left: .6875, width: .25, height: .5 }
    ],
    '2x1': [
        { top: .25, left: 0, width: 0.496875, height: .5 },
        { top: .25, left: .503125, width: 0.496875, height: .5 }
    ],
    'timed': [
        { top: .25, left: 0, width: .5, height: .5, time: 31.97, duration: 7 },
        { top: .25, left: .5, width: .5, height: .5, time: 31.97, duration: 7 },

        { top: .1657, left: 0, width: .66, height: .6616, time: 43.57, duration: 6.5 },
        { top: .1657, left: .6625, width: .3346, height: .3218, time: 43.67, duration: 6.5 },
        { top: .4917, left: .6625, width: .3346, height: .3218, time: 43.67, duration: 6.5 },

        { top: 0, left: 0, width: .5, height: .5, time: 55.23, duration: 5.77 },
        { top: 0, left: .5, width: .5, height: .5, time: 55.23, duration: 5.77 },
        { top: .5, left: 0, width: .5, height: .5, time: 55.23, duration: 5.77 },
        { top: .5, left: .5, width: .5, height: .5, time: 55.23, duration: 5.77 },

        { top: .1157, left: 0, width: .7463, height: .7671, time: 61.07, duration: 12.16 },
        { top: .1157, left: .7495, width: .2419, height: .7671, time: 61.07, duration: 12.16 },

        { top: .7417, left: .7400, width: .2419, height: .2412, time: 89.43, duration: 9.07 },

        { top: .0625, left: .0427, width: .4141, height: .4141, time: 98.57, duration: 9.13 }
    ],
    'demo': [
        { top: 0, left: 0, width: .5, height: .5, time: 0, duration: 65 },
        { top: 0, left: .5, width: .5, height: .5, time: 0, duration: 65 },
        { top: .5, left: 0, width: .5, height: .5, time: 0, duration: 65 },
        { top: .5, left: .5, width: .5, height: .5, time: 0, duration: 65 },

        { top: 1 / 6, left: 0, width: 2 / 3, height: 2 / 3, time: 67, duration: 48 },
        { top: 1 / 6, left: 2 / 3, width: 1 / 3, height: 1 / 3, time: 67, duration: 48 },
        { top: 1 / 2, left: 2 / 3, width: 1 / 3, height: 1 / 3, time: 67, duration: 48 },

        { top: .25, left: 0, width: 0.5, height: .5, time: 117, duration: 75 },
        { top: .25, left: 0.5, width: 0.5, height: .5, time: 117, duration: 75 }
    ]
}

export default LAYOUTS;
